import './help-me-choose-answers.scss';

import { t } from 'i18next';
import { parseAsString, useQueryState } from 'nuqs';

import { Checkbox } from '@sola/ark-core/molecules/checkbox/checkbox.js';

import { SelectionCard } from '../../../molecules/selection-card/selection-card';
import { disabilityImage } from '../images/disability-help-me-choose';
import { greatestNeedImage } from '../images/greatest-need-help-me-choose';
import { hivAidsImage } from '../images/hiv-help-me-choose';
import { vulnerableImage } from '../images/vulnerable-help-me-choose';

export const causeAnswers = [
  {
    id: 'hiv',
    value: 'affectedHiv',
    image: hivAidsImage,
  },
  {
    id: 'exploitation',
    value: 'vulnerableExploitation',
    image: vulnerableImage,
  },
  {
    id: 'disability',
    value: 'hasDisabilities',
    image: disabilityImage,
  },
  {
    id: 'anywhere',
    value: 'anywhere',
    image: greatestNeedImage,
  },
];

export const HelpMeChooseCause: React.FC<{
  anyCause: boolean;
  setAnyCause: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ anyCause, setAnyCause }) => {
  const [causes, setCauses] = useQueryState('filters', parseAsString);

  const handleCheckboxChange = (value: string, isChecked: boolean) => {
    if (value === 'anywhere') {
      setAnyCause(isChecked);
      setCauses(null);
    }
    if (value !== 'anywhere') {
      setCauses(isChecked ? value : null);
      setAnyCause(false);
    }
  };

  return (
    <div className="HelpMeChooseAnswers grid grid-cols-1 sm:grid-cols-2 gap-comfy-sm lg:flex lg:flex-row justify-center">
      {causeAnswers.map((card) => (
        <Checkbox
          name={card.id}
          fieldClasses="Checkbox__card"
          label={t(`help-me:howAnswers.${card.id}`)}
          checked={
            card.id === 'anywhere' ? !causes && anyCause : causes === card.value
          }
          onChange={(e) =>
            handleCheckboxChange(card.value, e.currentTarget.checked)
          }
          labelContent={
            <SelectionCard
              variant="stacked"
              isChecked={
                card.id === 'anywhere'
                  ? !causes && anyCause
                  : causes === card.value
              }
              details={{
                image: {
                  alt: t(`help-me:howAnswers.${card.id}Alt`),
                  url: card.image,
                },
                label: t(`help-me:howAnswers.${card.id}`),
                primaryText: t(`help-me:howAnswers.${card.id}PrimaryText`),
                secondaryTitle: t(
                  `help-me:howAnswers.${card.id}SecondaryTitle`,
                ),
                secondaryText: t(`help-me:howAnswers.${card.id}SecondaryText`),
                value: card.value,
              }}
            />
          }
        />
      ))}
    </div>
  );
};
